import React, { memo, useCallback, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '../../../material-ui/TextField';
import { useStyles } from './useStyles';
import { darkFullWhite } from '../../../../service/getMuiThemeStyle';
import { Tooltip } from '../../../material-ui/Tooltip';

import { IconButton } from '../../../material-ui/IconButton';
import { Refresh } from '../../../../icons';
import { Typography } from '../../../material-ui/Typography';
import { Timer } from '../../../Timer/Timer';

const REFRESH_TIMEOUT = 60;

export const TwoFactor = memo(
    forwardRef(({ onChange, value, dark, refreshBlocked, changeRefreshBlocked, onRequestCode, sendingInfo, isWhiteColor = true }, ref) => {
        const classes = useStyles({ isWhiteColor });
        const { t: translate } = useTranslation();

        const handleTimeEnd = useCallback(() => {
            changeRefreshBlocked(false);
        }, [changeRefreshBlocked]);

        return (
            <>
                <TextField
                    ref={ref}
                    required={true}
                    type="confirmationCode"
                    name="confirmationCode"
                    label={translate('loginPage.confirmationCode')}
                    onChange={onChange}
                    value={value}
                    fullWidth={true}
                    className={classes.field}
                    InputProps={{
                        style: {
                            color: isWhiteColor ? darkFullWhite : 'default',
                        },
                        endAdornment: refreshBlocked ? (
                            <Tooltip title={translate('loginPage.refreshCode')}>
                                <Timer seconds={REFRESH_TIMEOUT} onTimeEnd={handleTimeEnd} />
                            </Tooltip>
                        ) : (
                            <IconButton className={classes.icon} onClick={onRequestCode}>
                                <Refresh fontSize="small" />
                            </IconButton>
                        ),
                    }}
                    {...(dark && {
                        InputLabelProps: {
                            style: {
                                color: darkFullWhite,
                            },
                        },
                    })}
                />
                {!!sendingInfo && (
                    <Typography className={classes.sendingInfo} variant={'caption'}>
                        {translate('loginPage.willSendConfirmationCode')} <span>{sendingInfo}</span>
                    </Typography>
                )}
            </>
        );
    })
);
